import { Component, Host, h, Element, State, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';

interface UiCmsContentFooterProps {
  isHidingPrint: boolean;
  isHidingScrollToTop: boolean;
}

@Component({
  tag: 'ui-cms-content-footer',
  styleUrl: 'ui-cms-content-footer.scss',
})
export class UiCmsContentFooter {
  @Element() el: HTMLUiCmsContentFooterElement;

  @State() iconsOnly: boolean;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ mutable: true }) body: UiCmsContentFooterProps = {
    isHidingPrint: false,
    isHidingScrollToTop: false,
  };

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Prop({ mutable: true }) i18n = {
    print: 'Drucken',
    scrollTop: 'Nach oben',
  };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  onPrintClick() {
    window.print();
    window.ui?.services?.tracking?.track({
      eventInfo: {
        eventName: 'Click Content Footer Print Button',
        eventType: 'Action',
      },
      category: {
        area: 'Content',
      },
      attributes: {
        elementType: 'Button',
        elementLabel: 'Drucken',
        target: window.location.href,
      },
    } as ActionTrackingEvent);
  }

  onScrollTopClick() {
    window.ui?.services?.tracking?.track({
      eventInfo: {
        eventName: 'Click Content Footer Scroll to top',
        eventType: 'Action',
      },
      category: {
        area: 'Content',
      },
      attributes: {
        elementType: 'Button',
        elementLabel: 'Nach_oben',
        target: window.location.href,
      },
    } as ActionTrackingEvent);

    const currentlyFocusedElement = document.activeElement as HTMLElement;
    currentlyFocusedElement.blur();
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
    this.utilityI18nChangeHandler(this.utilityI18n);
  }

  render() {
    return (
      <Host>
        <div class="buttons-wrapper">
          {!this.body.isHidingPrint && (
            <sd-button class="buttons-wrapper__print" variant="secondary" onClick={() => this.onPrintClick()}>
              <sd-icon
                slot="icon-left"
                name="union-investment/system/print"
                library={window.ui.cmsState.iconLibrary}
              ></sd-icon>
              {this.i18n.print}
            </sd-button>
          )}
          {!this.body.isHidingScrollToTop && (
            <sd-button
              class="buttons-wrapper__scroll"
              variant="secondary"
              href="#"
              onClick={() => this.onScrollTopClick()}
            >
              <sd-icon
                slot="icon-left"
                name="union-investment/system/arrow-top"
                library={window.ui.cmsState.iconLibrary}
              ></sd-icon>
              {this.i18n.scrollTop}
            </sd-button>
          )}
        </div>
      </Host>
    );
  }
}
